function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M-17023-4294a8.011 8.011 0 0 1-8-8 8.011 8.011 0 0 1 8-8 8.011 8.011 0 0 1 8 8 8.011 8.011 0 0 1-8 8zm0-7.074 1.881 1.88a.647.647 0 0 0 .475.192.645.645 0 0 0 .648-.654.622.622 0 0 0-.191-.457l-1.885-1.889 1.885-1.894a.615.615 0 0 0 .2-.453.645.645 0 0 0-.65-.654.627.627 0 0 0-.471.2l-1.893 1.885-1.895-1.881a.6.6 0 0 0-.461-.192.643.643 0 0 0-.654.646.6.6 0 0 0 .2.457l1.881 1.89-1.881 1.893a.606.606 0 0 0-.2.453.647.647 0 0 0 .654.654.628.628 0 0 0 .475-.192l1.881-1.88z",
  transform: "translate(17031.002 4310.001)"
}));

function SvgCloseChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.004 16.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseChip);
export default __webpack_public_path__ + "static/media/close_chip.cb8ff854.svg";
export { ForwardRef as ReactComponent };